import { any } from 'prop-types';

// all svg components can accept these
// only <SVG /> can accept all normal ViewStylePropTypes
export const CSSPropTypes = {
  display: any,
  cursor: any,
  visibility: any,
  overflow: any,
  opacity: any,
  color: any,
};

export const ColorPropTypes = {
  color: any,
  stopColor: any,
  fill: any,
  stroke: any,
};

export const TransformPropTypes = {
  translate: any,
  translateX: any,
  translateY: any,
  origin: any,
  originX: any,
  originY: any,
  scale: any,
  scaleX: any,
  scaleY: any,
  skew: any,
  skewX: any,
  skewY: any,
  rotation: any,
  x: any,
  y: any,
  transform: any,
};

export const ClipPropTypes = {
  clipPath: any,
  clipRule: any, // evenodd | nonzero
};

export const FillPropTypes = {
  fill: any,
  fillRule: any,
  fillOpacity: any,
};

export const StrokePropTypes = {
  stroke: any,
  strokeWidth: any,
  strokeOpacity: any,
  strokeDasharray: any,
  strokeDashoffset: any,
  strokeLinecap: any,
  strokeLinejoin: any,
  strokeMiterlimit: any,
  vectorEffect: any,
};

export const FontPropTypes = {
  fontData: any,
  fontStyle: any,
  fontVariant: any,
  fontWeight: any,
  fontStretch: any,
  fontSize: any,
  fontFamily: any,
  textAnchor: any,
  textDecoration: any,
  letterSpacing: any,
  wordSpacing: any,
  kerning: any,
  fontFeatureSettings: any,
  fontVariantLigatures: any,
  fontVariationSettings: any,
  font: any,
};

export const RectPropTypes = {
  x: any,
  y: any,
  width: any,
  height: any,
};

export const TextPropTypes = {
  x: any,
  y: any,
  dx: any,
  dy: any,
  rotate: any, // TODO: <- this conflicts with normal styling FYI
  inlineSize: any,
  baselineShift: any,
  verticalAlign: any,
  alignmentBaseline: any,
};

export const SvgPropTypes = {
  ...RectPropTypes,
  ...FillPropTypes,
  ...StrokePropTypes,
  ...ClipPropTypes,
  ...CSSPropTypes,
  ...FontPropTypes,
  viewBox: any,
};
